import "./ImagePreview.scss";
import draggable from "vuedraggable";
import { clipperBasic } from "vuejs-clipper";
import { getImageSize } from "@/helpers/commonHelper";
import _ from "lodash";
import axios from "axios";
import ChannelSelection from "@/components/Events/ChannelSelection/ChannelSelection.vue";
import { mainChannels } from "@/configuration/channelConfiguration";

export default {
  name: "ImagePreview",
  props: [
    "files",
    "minWidth",
    "minHeight",
    "aspectRatio",
    "showControls",
    "hideLabel",
    "imageHeight",
    "canCrop",
    "isEventImage",
    "imageSizeField",
    "editedItem"
  ],
  data: () => ({
    selectError: "",
    scaleToolArea: 100,
    isLoading: true,
    cachedSizes: [],
    dialog: false,
    clipper: null,
    editDialog: false,
    licenseDialog: false,
    licenseInitial: { type: "" },
    ratioIndex: 0,
    selectedRatio: "16:9",
    fileToEdit: {
      license: {
        type: ""
      },
      channels: []
    },
    fileToEditOriginal: {},
    mainAllYearIndex: -1,
    mainWinterIndex: -1,
    mainSummerIndex: -1,
    showImageInOptions: [
      { title: "Galerie", value: "gallery" },
      { title: "Content", value: "content" }
    ],
    // TODO: Ganz dringend in die DB verschieben
    licenseTypes: [
      {
        id: "CC-BY",
        label: "CC BY",
        requires: ["author"],
        info:
          "Diese Lizenz erlaubt Dritten, ein Werk zu verbreiten, zu remixen, " +
          "zu verbessern und darauf aufzubauen, auch kommerziell, solange der Urheber des Originals genannt wird."
      },
      {
        id: "CC-BY-SA",
        label: "CC BY SA",
        requires: ["author"],
        info:
          "Diese Lizenz erlaubt es Dritten, ein Werk zu verbreiten, zu remixen, zu verbessern und darauf " +
          "aufzubauen, auch kommerziell, solange der Urheber des Originals genannt wird und die auf seinem " +
          "Werk basierenden neuen Werke unter denselben Bedingungen veröffentlicht werden."
      },
      {
        id: "CC-BY-ND",
        label: "CC BY ND",
        requires: ["author"],
        info:
          "Diese Lizenz erlaubt Dritten die Weiterverbreitung des Werkes, kommerziell wie nicht-kommerziell, " +
          "solange dies ohne Veränderungen und vollständig geschieht und der Urheber genannt wird."
      },
      {
        id: "CC-BY-NC",
        label: "CC BY NC",
        requires: ["author"],
        info:
          "wie CC BY – zusätzlich mit der Einschränkung „nur nicht kommerziell“"
      },
      {
        id: "CC-BY-NC-SA",
        label: "CC BY NC SA",
        requires: ["author"],
        info:
          "wie CC BY SA – zusätzlich mit der Einschränkung „nur nicht kommerziell“"
      },
      {
        id: "CC-BY-NC-ND",
        label: "CC BY NC ND",
        requires: ["author"],
        info:
          "wie CC BY ND – zusätzlich mit der Einschränkung „nur nicht kommerziell“"
      },
      {
        id: "CC0",
        label: "CC0",
        requires: [],
        info: "Verzicht auf alle urheberrechtlichen und verwandten Schutzrechte"
      }
    ]
  }),
  components: { draggable, clipperBasic, ChannelSelection },
  mounted() {
    this.setSummerWinterIndex();
  },
  methods: {
    checkSelection() {
      this.selectError = "";
      if (
        !this.fileToEdit?.[this.imageSizeField]?.[this.selectedRatio]?.width
      ) {
        this.selectError =
          "Bitte wählen sie einen Bild-Ausschnitt für eine optimale Darstellung des Bildes im Internet. Das Bild sollte eine Mindestbreite von 1280 Pixeln haben.";
      }
    },
    removeFile(index) {
      this.$emit("removeFile", index);
    },
    async saveClippedImage(url, close) {
      let clipperBottom, clipperRight, left, right, bottom, top, width, height;

      const clipper = this.$refs.clipper?.length
        ? this.$refs.clipper[0]
        : this.$refs.clipper;
      const file = this.cFiles.find(file => file.url === url);
      const imageUrl = file.url || file.originalUrl;
      const imageSizes =
        this.cachedSizes[imageUrl] || (await getImageSize(imageUrl));
      if (imageSizes) this.cachedSizes[imageUrl] = imageSizes;

      const clipperWidth = Math.floor(
        (clipper.zoomWH$.width / 100) * imageSizes.width
      );
      const clipperHeight = Math.floor(
        (clipper.zoomWH$.height / 100) * imageSizes.height
      );
      if (Number.isNaN(clipperHeight) || clipperHeight === 0) {
        await this.$store.dispatch("createError", {
          text: "Nicht gespeichert. Kein Ausschnitt gewählt!"
        });
        if (close) this.dialog = false;
        return;
      }
      const clipperLeft = Math.floor(
        (clipper.zoomTL$.left / 100) * imageSizes.width
      );
      const clipperTop = Math.floor(
        (clipper.zoomTL$.top / 100) * imageSizes.height
      );

      if (clipper.zoomTL$.right)
        clipperRight = (clipper.zoomTL$.right / 100) * imageSizes.width;
      if (clipper.zoomTL$.bottom)
        clipperBottom = (clipper.zoomTL$.bottom / 100) * imageSizes.height;

      if (!clipperRight) {
        right = this.calculateRight(
          clipperLeft,
          Math.floor(imageSizes.width),
          clipperWidth
        );
      } else {
        right = clipperRight;
      }

      if (!clipperBottom) {
        bottom = this.calculateBottom(
          clipperTop,
          Math.floor(imageSizes.height),
          clipperHeight
        );
      } else {
        bottom = clipperBottom;
      }
      top = parseInt(clipperTop);
      height = parseInt(clipperHeight);
      left = parseInt(clipperLeft);
      width = parseInt(clipperWidth);

      const urlArray = file.url.split("/");

      urlArray.splice(3, 0, `focus/${left}/${top}/${width}/${height}`);

      const focusUrl = urlArray.join("/");

      //check if imaginary can crop the image
      try {
        await axios.get(focusUrl);
      } catch (error) {
        if (error.response) {
          await this.$store.dispatch("createError", error);
          if (close) this.dialog = false;
          return;
        }
      }

      const ratioObj = {
        width,
        height,
        left,
        top,
        right,
        bottom,
        url: focusUrl
      };

      if (file[this.imageSizeField])
        file[this.imageSizeField][this.selectedRatio] = ratioObj;
      else
        file[this.imageSizeField] = {
          [this.selectedRatio]: ratioObj
        };
      this.checkSelection();
      if (close) this.dialog = false;
    },

    close() {
      this.dialog = false;
    },
    async setIndex(index, ratio) {
      this.isLoading = true;
      await this.saveClippedImage(this.fileToEdit.url, false);
      this.ratioIndex = index;
      this.selectedRatio = ratio.key ?? ratio.title;
      await this.setCropperPos();
      this.checkSelection();
      this.isLoading = false;
    },
    openClipperDialog(url) {
      this.fileToEdit = this.cFiles.find(file => file.url === url);
      if (!this.fileToEdit.license) this.fileToEdit.license = {};
      if (!this.fileToEdit.channels) this.fileToEdit.channels = [];

      this.dialog = true;
    },
    openEditDialog(url) {
      // critical for binding with empty license.type-property (selectedLicense)
      // (slight changes might break "selectedLicense")
      const fileTemp = this.cFiles.find(file => file.url === url);
      if (!fileTemp.license) {
        fileTemp.license = { ...this.licenseInitial };
      }
      if (!fileTemp.channels) fileTemp.channels = [];
      this.fileToEdit = fileTemp;
      this.fileToEditOriginal = { ...fileTemp };

      this.editDialog = true;
    },
    cancelEditDialog() {
      const index = this.cFiles.findIndex(
        file => file.url === this.fileToEditOriginal.url
      );
      this.cFiles[index] = _.cloneDeep(this.fileToEditOriginal);
      this.editDialog = false;
    },
    openLicenseDialog() {
      this.licenseDialog = true;
    },
    cancelLicense() {
      this.fileToEdit.license = { ...this.licenseInitial };
      this.licenseDialog = false;
    },
    saveDetails() {
      const index = this.cFiles.findIndex(
        file => file.url === this.fileToEdit.url
      );
      this.cFiles[index] = _.cloneDeep(this.fileToEdit);
      this.editDialog = false;
    },
    calculateRight(posLeft, imageWidth, canvasWidth) {
      return imageWidth - (posLeft + canvasWidth);
    },

    calculateBottom(posTop, imageHeight, canvasHeight) {
      return imageHeight - (posTop + canvasHeight);
    },
    getImageUrl(image) {
      return (
        image?.url ??
        image?.originalUrl ??
        image?.[this.imageSizeField]?.[this.selectedRatio]?.url ??
        ""
      );
    },
    async setCropperPos() {
      this.isLoading = true;
      const selectSize = this.fileToEdit?.[this.imageSizeField]?.[
        this.selectedRatio
      ];
      let {
        widthPercentage,
        heightPercentage,
        leftPercentage,
        topPercentage
      } = await this.getCropperPos(
        this.fileToEdit.url || this.fileToEdit.originalUrl,
        selectSize ?? {}
      );
      //nothing selected? use default selection
      if (!selectSize) {
        widthPercentage = heightPercentage = 0;
        leftPercentage = topPercentage = 5;
      }

      setTimeout(() => {
        this.$refs.clipper.setWH$.next({
          width: widthPercentage,
          height: heightPercentage
        });
        this.$refs.clipper.setTL$.next({
          left: leftPercentage,
          top: topPercentage
        });
      }, 10);
      this.isLoading = false;
    },
    async getCropperPos(imageUrl, { top, left, width, height }) {
      const imageSizes =
        this.cachedSizes[imageUrl] || (await getImageSize(imageUrl));
      if (imageSizes) this.cachedSizes[imageUrl] = imageSizes;

      const imageWidth = imageSizes.width;
      const imageHeight = imageSizes.height;

      this.scaleToolArea = 100;
      if (!imageHeight || window.innerHeight * 0.6 < imageHeight) {
        const newHeight = parseInt(window.innerHeight * 0.5);
        const newPercent = parseInt((100 * newHeight) / imageHeight);
        this.scaleToolArea = newPercent;
      }

      const leftPercentage = (left / imageWidth) * 100;
      const topPercentage = (top / imageHeight) * 100;

      const widthPercentage = (width / imageWidth) * 100;
      const heightPercentage = (height / imageHeight) * 100;

      const ratio = this.aspectRatio?.find(r => r.key === this.selectedRatio)
        ?.ratio;

      let fallbackWidthPercent = 100;
      const fallbackHeightPx = imageWidth / ratio;
      let fallbackHeightPercent =
        (fallbackHeightPx / imageHeight) * fallbackWidthPercent;
      if (fallbackHeightPercent > 100) {
        fallbackHeightPercent = 100;
        const fallbackWidthPx = imageHeight * ratio;
        fallbackWidthPercent =
          (fallbackWidthPx / imageWidth) * fallbackHeightPercent;
      }
      if (this.scaleToolArea < 50) this.scaleToolArea = 50;
      return {
        widthPercentage: !isNaN(widthPercentage)
          ? widthPercentage
          : fallbackWidthPercent,
        heightPercentage: !isNaN(heightPercentage)
          ? heightPercentage
          : fallbackHeightPercent,
        leftPercentage: !isNaN(leftPercentage) ? leftPercentage : 0,
        topPercentage: !isNaN(topPercentage) ? topPercentage : 0
      };
    },

    setSummerWinterIndex() {
      this.mainAllYearIndex = -1;
      this.mainWinterIndex = -1;
      this.mainSummerIndex = -1;

      if (this.cFiles?.length) {
        this.cFiles.forEach((file, index) => {
          switch (file?.type) {
            case "winter":
              if (this.mainWinterIndex < 0) {
                this.mainWinterIndex = index;
              }
              break;
            case "summer":
              if (this.mainSummerIndex < 0) {
                this.mainSummerIndex = index;
              }
              break;
            default:
              if (this.mainAllYearIndex < 0) {
                this.mainAllYearIndex = index;
              }
              break;
          }
        });
      }
      if (
        this.mainAllYearIndex > -1 &&
        this.mainAllYearIndex < this.mainSummerIndex
      ) {
        this.mainSummerIndex = -1;
      }
      if (
        this.mainAllYearIndex > -1 &&
        this.mainAllYearIndex < this.mainWinterIndex
      ) {
        this.mainWinterIndex = -1;
      }
      if (
        this.mainSummerIndex > -1 &&
        this.mainWinterIndex > -1 &&
        (this.mainAllYearIndex > this.mainSummerIndex ||
          this.mainAllYearIndex > this.mainWinterIndex)
      ) {
        this.mainAllYearIndex = -1;
      }
    },
    getMainImageLabel(index) {
      if (index === this.mainAllYearIndex) {
        return "Hauptbild";
      }
      if (index === this.mainWinterIndex) {
        return "Hauptbild (Winter)";
      }
      if (index === this.mainSummerIndex) {
        return "Hauptbild (Sommer)";
      }

      return null;
    }
  },
  computed: {
    channels() {
      return mainChannels.filter(c =>
        this.editedItem?.channels?.includes(c.value)
      );
    },
    stencilProps() {
      const props = {};
      if (this.minWidth) props.minWidth = this.minWidth;
      if (this.minHeight) props.minHeight = this.minHeight;
      if (this.aspectRatio) props.aspectRatio = this.aspectRatio;
      return props;
    },
    cFiles: {
      get() {
        return this.files;
      },
      set(newVal) {
        this.$emit("setFileUrls", newVal);
      }
    },
    calculatedCols() {
      return this.aspectRatio && this.aspectRatio.length
        ? Math.floor(12 / this.aspectRatio.length)
        : 3;
    },
    selectedLicense() {
      return (
        this.licenseTypes.find(lt => lt.id === this.fileToEdit.license.type) ??
        {}
      );
    },
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    customPoiImageTypes() {
      return this.principal?.poiImageTypes || [];
    },
    imageUrl() {
      return this.fileToEdit.url || this.fileToEdit.originalUrl;
    },
    showImageAspectRatioButtons() {
      return this.principal?.id === "515b69ad-cd70-433f-a9ca-faf42a1d219f";
    }
  },
  watch: {
    imageUrl() {
      this.isLoading = true;
    },
    fileToEdit() {
      this.checkSelection();
    }
  }
};
